module.exports = __webpack_public_path__ + "img/news_on.fda7ac7b.png";